module.exports = __webpack_public_path__ + "static/media/clock-blue-timer.68dae936.svg";